/**
 * Write an entry to activity_logs (audit trail).
 * Call after create/update/delete on key entities.
 * @param {object} supabase - Supabase client
 * @param {string|null} userId - auth user id (from useAuth().user?.id)
 * @param {{ action: string, entity_type: string, entity_id?: string, title?: string, details?: object }} opts
 */
export async function logActivity(supabase, userId, opts) {
  if (!supabase || !opts?.action || !opts?.entity_type) return;
  await supabase.from('activity_logs').insert({
    user_id: userId || null,
    action: opts.action,
    entity_type: opts.entity_type,
    entity_id: opts.entity_id ?? null,
    title: opts.title ?? null,
    details: opts.details ?? null,
  });
}
